import { Forbidden } from '@/features/errors';

const NoPermission = () => {
  return <Forbidden />;
};

export default NoPermission;
